export default {
    "headers": {
        "timeSlot": "时间",
        "no": "序号",
        "time": "时间",
        "eventName": "名称",
        "location": "地址"
    },
    "groups": [
        {
            "title": "3月31日上午",
            "items": [
                {
                    "no": "1",
                    "time": "10:00-11:00",
                    "event": "住宅品质提升新闻通气会",
                    "location": "建设大厦"
                }
            ]
        },
        {
            "title": "3月31日下午(共2场)",
            "items": [
                {
                    "no": "2",
                    "time": "14:30-17:30",
                    "event": "推动住房公积金管理系统国产化替代专题交流会",
                    "location": "南京中兴和泰酒店三楼会议室"
                },
                {
                    "no": "3",
                    "time": "16:30-18:00",
                    "event": "改善型住宅工作座谈会(房管处)",
                    "location": "珍宝假日酒店(奥体店)"
                }
            ]
        },
        {
            "title": "4月1日上午(共8场)",
            "items": [
                {
                    "no": "/",
                    "time": "09:00-10:10",
                    "event": "开馆仪式、巡展",
                    "location": "1号馆"
                },
                {
                    "no": "4",
                    "time": "09:00-11:30",
                    "event": "基于数字双碳和多维融合的城市照明低碳发展专题交流会  (闭门会)",
                    "location": "会议中心3F302"
                },
                {
                    "no": "5",
                    "time": "09:45-12:00",
                    "event": "长三角建筑能效测评与碳排放核定专题交流会暨第十七届江苏绿色建筑发展大会   (闭门会)",
                    "location": "会议中心3F303"
                },
                {
                    "no": "6",
                    "time": "10:30-11:30",
                    "event": "改善型住宅大家谈",
                    "location": "1号展馆活动区"
                },
                {
                    "no": "7",
                    "time": "11:00-12:00",
                    "event": "江苏省建科院“低碳未来建筑”主题发布会",
                    "location": "2号展馆1号活动区"
                },
                {
                    "no": "8",
                    "time": "11:00-12:00",
                    "event": "“绿建未来-金融赋能”相关金融服务产品发布会",
                    "location": "2号展馆2号活动区"
                },
                {
                    "no": "9",
                    "time": "10:30-11:00",
                    "event": "与江苏银行会晤",
                    "location": "展馆2楼1202"
                },
                {
                    "no": "10",
                    "time": "10:20-10:50",
                    "event": "与中建科工会晤",
                    "location": "展馆2楼1203"
                }
            ]
        },
        {
            "title": "4月1日下午(共13场)",
            "items": [
                {
                    "no": "11",
                    "time": "14:00-16:00",
                    "event": "改善型住宅工作培训(闭门会)",
                    "location": "会议中心2F201"
                },
                {
                    "no": "12",
                    "time": "14:00-17:30",
                    "event": "现代化基础设施更安全、更低碳、更智慧、更长久专题交流会(闭门会)",
                    "location": "会议中心2F202"
                },
                {
                    "no": "13",
                    "time": "14:00-17:00",
                    "event": "智能建造专业人才培养交流会(闭门会)",
                    "location": "会议中心3F扬子厅"
                },
                {
                    "no": "14",
                    "time": "14:30-17:00",
                    "event": "江苏省住房和城乡建设厅科学技术委员会全体会议(闭门会)",
                    "location": "会议中心3F302"
                },
                {
                    "no": "15",
                    "time": "14:00-17:30",
                    "event": "江苏省城市生命线安全工程解决方案发布会",
                    "location": "会议中心3F303"
                },
                {
                    "no": "16",
                    "time": "13:30-17:00",
                    "event": "夏热冬冷地区低碳智慧冷热源解决方案学术交流会",
                    "location": "会议中心4F402"
                },
                {
                    "no": "17",
                    "time": "14:00-18:00",
                    "event": "“存量背景下城市公园绿地的更新赋能与增值服务”专题交流会(闭门会)",
                    "location": "会议中心4F403"
                },
                {
                    "no": "18",
                    "time": "14:00-16:30",
                    "event": "政府投资工程集中建设绿色低碳建筑成果展及项目发布会",
                    "location": "1号展馆活动区"
                },
                {
                    "no": "19",
                    "time": "13:30-16:00",
                    "event": "建筑碳排放计算相关专题交流暨东禾建筑碳排放计算分析软件发布会",
                    "location": "2号展馆1号活动区"
                },
                {
                    "no": "20",
                    "time": "12:55-14:00",
                    "event": "中建协认证中心常州分公司授牌仪式暨绿色建筑创新发展交流会",
                    "location": "2号展馆2号活动区"
                },
                {
                    "no": "21",
                    "time": "14:30-17:00",
                    "event": "高层建筑“消防保保险+服务”项目新产品发布",
                    "location": "2号展馆2号活动区"
                },
                {
                    "no": "22",
                    "time": "15:00-15:30",
                    "event": "与中兴会晤展馆",
                    "location": "展馆2楼1202"
                }
            ]
        },
        {
            "title": "4月2日上午(共10场)",
            "items": [
                {
                    "no": "23",
                    "time": "09:00-11:30",
                    "event": "建筑垃圾资源化利用专题交流会(闭门会)",
                    "location": "会议中心3F302"
                },
                {
                    "no": "24",
                    "time": "09:00-12:00",
                    "event": "城市更新与城市照明发展交流会(闭门会)",
                    "location": "会议中心3F303"
                },
                {
                    "no": "25",
                    "time": "09:00-12:00",
                    "event": "AI赋能住房城乡建设高质量发展专题交流会",
                    "location": "会议中心4F402"
                },
                {
                    "no": "26",
                    "time": "09:00-12:00",
                    "event": "“迈向碳中和：可持续性城市更新与既有建筑绿色低碳改造”国际学术会议(闭门会)",
                    "location": "会议中心4F403"
                },
                {
                    "no": "27",
                    "time": "09:30-11:30",
                    "event": "荷兰-江苏绿色低碳建筑技术交流会",
                    "location": "1号展馆活动区"
                },
                {
                    "no": "28",
                    "time": "09:00-11:30",
                    "event": "“新质生产力”助力建筑消防安全技术交流会",
                    "location": "2号展馆1号活动区"
                },
                {
                    "no": "29",
                    "time": "09:00-12:00",
                    "event": "城市道路低碳养护技术可持续发展技术交流会",
                    "location": "展馆2楼2202"
                },
                {
                    "no": "30",
                    "time": "09:00-11:30",
                    "event": "江苏省建筑产业现代化促进会第一届理事会第三次会议暨经验技术交流会",
                    "location": "新华传媒大酒店一楼翔宇厅"
                },
                {
                    "no": "31",
                    "time": "10:30-11:00",
                    "event": "与英达科技集团会晤",
                    "location": "英达展区"
                },
                {
                    "no": "32",
                    "time": "10:00-11:00",
                    "event": "与交通银行江苏省分行会晤",
                    "location": "展馆2楼1202"
                }
            ]
        },
        {
            "title": "4月2日下午(共14场)",
            "items": [
                {
                    "no": "33",
                    "time": "13:30-15:00",
                    "event": "江苏省照明学会理事会会议(闭门会)",
                    "location": "会议中心2F203"
                },
                {
                    "no": "34",
                    "time": "14:00-16:30",
                    "event": "Aiot赋能建筑低碳专题交流会暨第十七届江苏绿色建筑发展大会  (闭门会)",
                    "location": "会议中心2F206"
                },
                {
                    "no": "35",
                    "time": "14:00-17:30",
                    "event": "江苏省土木建筑学会临时会员代表大会暨十一届理事会第四次会议、江苏土木工程大讲堂",
                    "location": "会议中心3F钟山厅"
                },
                {
                    "no": "36",
                    "time": "14:00-17:00",
                    "event": "江苏省建筑产业现代化促进会集成模块建筑分会成立大会暨发展交流会",
                    "location": "会议中心3F扬子厅"
                },
                {
                    "no": "37",
                    "time": "14:00-17:00",
                    "event": "江苏省建设机械金属结构协会幕墙门窗遮阳行业分会年会暨   “好房子好门窗”产业发展交流会",
                    "location": "会议中心3F302"
                },
                {
                    "no": "38",
                    "time": "14:00-17:30",
                    "event": "“数字化赋能设计创新发展”专题交流会(闭门会)",
                    "location": "会议中心3F303"
                },
                {
                    "no": "39",
                    "time": "14:00-17:30",
                    "event": "现代宜居农房建设培训会(闭门会)",
                    "location": "会议中心4F402"
                },
                {
                    "no": "/",
                    "time": "14:00-18:00",
                    "event": "“迈向碳中和：可持续性城市更新与既有建筑绿色低碳改造”国际学术会议(闭门会)",
                    "location": "会议中心4F403"
                },
                {
                    "no": "40",
                    "time": "16:00-18:00",
                    "event": "名家话绿建 ·数智融合，助力城乡建设绿色低碳发展",
                    "location": "1号展馆活动区"
                },
                {
                    "no": "41",
                    "time": "14:30-16:00",
                    "event": "江苏省城乡建设碳达峰碳中和先导区推介发布",
                    "location": "2号展馆1号活动区"
                },
                {
                    "no": "42",
                    "time": "14:00-17:30",
                    "event": "建设领域科协青年科技人才学术成果专题交流会",
                    "location": "2号展馆2号活动区"
                },
                {
                    "no": "43",
                    "time": "15:30-16:30",
                    "event": "与浪潮集团会晤",
                    "location": "展馆2楼1202"
                },
                {
                    "no": "44",
                    "time": "17:00-17:30",
                    "event": "与通力中国会晤",
                    "location": "展馆2楼1202"
                },
                {
                    "no": "45",
                    "time": "13:30-17:30",
                    "event": "江苏鸿蒙智家产业峰会",
                    "location": "河西金鹰G酒店9楼"
                }
            ]
        },
        {
            "title": "4月3日上午(共2场)",
            "items": [
                {
                    "no": "46",
                    "time": "10:00-12:00",
                    "event": "江苏公共建筑能源医院揭牌仪式",
                    "location": "1号展馆活动区"
                },
                {
                    "no": "47",
                    "time": "09:00-12:00",
                    "event": "建设科技创新成果分享",
                    "location": "2号展馆2号活动区"
                }
            ]
        }
    ]
};
